import type { Period } from '@/hooks/useDashboardMetrics';
import { cn } from '@/lib/utils';

interface DashboardPeriodSelectorProps {
  period: Period;
  onPeriodChange: (period: Period) => void;
  options: { value: Period; label: string }[];
  className?: string;
}

/** Day-range pills for dashboard metrics — scrolls with page content. */
export function DashboardPeriodSelector({
  period,
  onPeriodChange,
  options,
  className,
}: DashboardPeriodSelectorProps) {
  return (
    <div className={cn('flex items-center justify-end py-2 -mt-2 mb-1', className)}>
      <div className="flex items-center gap-1 rounded-lg bg-muted p-0.5 shadow-sm border border-border/50">
        {options.map(opt => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onPeriodChange(opt.value)}
            className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
              period === opt.value
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
